/// <amd-module name="Tfs/Header/Components/ShortcutMenuProvider" />
import React = require("react");
import Resources = require("Tfs/Header/Components/Resources");

import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssLayoutManager, IWrappedComponentProperties, WrappedComponent } from "VSS/Platform/Layout";
import { IMenuItem } from "VSSUI/Menu";

export class ShortcutMenuProviderService extends VssService {
    private _shortcutsAvailable: boolean;
    private menuItems: IMenuItem[] = [];

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);

        // Show the Shortcut menu when we are within the project context.
        const pageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
        const pageData = pageService.getData();

        this._shortcutsAvailable = !!pageData && !!pageData.project;
        if (this._shortcutsAvailable) {
            this.menuItems.push({
                id: "tfsShortcutKeys",
                text: Resources.KeyboardShortcuts,
                rank: 550,
                iconProps: { iconName: "KeyboardClassic" },
                groupKey: "other-actions",
                onActivate: () => {
                    this.showDialog();
                }
            });
        }
    }

    public getMenuItems = () => {
        return this.menuItems;
    };

    public showDialog(): void {
        const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutManager.renderCallout(onDismiss => {
            const props: IWrappedComponentProperties = {
                dependencies: ["ms.vss-tfs-web.keyboard-shortcuts-ui-content"],
                wrappedType: "KeyboardShortcutsPanel",
                wrappedProps: { onDismiss }
            };

            return React.createElement(WrappedComponent, props);
        });
    }
}

Services.add("ms.vss-tfs-web.shortcut-menu-provider", { serviceFactory: ShortcutMenuProviderService });
